import { Component, OnInit } from '@angular/core';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { SessionService } from '../../../services/session.service';
import { ParametroService } from '../../../services/parametro.service';
import { Pagination } from '../../../models/pagination';
import { OrdenCompraService } from '../../../services/orden-compra.service';
import { OrdenCompra } from '../../../models/orden-compra';
import { OrdenCompraModalComponent } from '../../modals/orden-compra-modal/orden-compra-modal.component';


@Component({
  selector: 'app-orden-compra-list',
  templateUrl: './orden-compra-list.component.html',
  styleUrls: ['./orden-compra-list.component.css'],
  providers:[ParametroService,OrdenCompraService]
})
export class OrdenCompraListComponent implements OnInit {

  public titulo: string;
  public loading: boolean;
  public ordenes: Array<OrdenCompra> = [];
  public msg: SweetMessage;
  public bsModalRef: BsModalRef;
  public numero_decimales: number;
  public format_decimal: String;
  public busqueda: String;
  public pagination: Pagination;

  constructor(
    public ordenService: OrdenCompraService,    		
    private modalService: BsModalService,	
    private ss: SessionService,
    private parametroService: ParametroService,
  ) { 
    this.titulo = "Orden compra";
    this.loading = false;
    this.msg = new SweetMessage();  
    this.numero_decimales = 2;
    this.format_decimal = "0,0.00";  
    this.busqueda = "";
    this.pagination = new Pagination();
  }

  ngOnInit() {
    let p1 = this.getParamNumeroDecimales();
    let p2 = this.getOrdenes();

    this.loading = true;
    Promise.all([p1,p2]).then(
      res => this.loading = false,
      err=> this.loading = false
    );
  }

  onSearch(event){
		this.busqueda = event.target.value;
		this.loading =true;
		this.getOrdenes().then(
			res => this.loading = false,
			err => this.loading = false
		);
		
  }

  getOrdenes() {
    return new Promise((resolve, reject)=>{
      let qs = "";
		
			if (this.busqueda != "") {
				qs = "&razon_social="+this.busqueda;
			}
      this.ordenService.getByFilter("?page="+this.pagination.current_page+"&per_page=10"+qs).subscribe(
        res => {
          
          this.ordenes = res.data; 
          // Paginación
          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        },
        err => {
          this.ordenes = [];
          reject(err);
        }
      );
    });
  }

  getParamNumeroDecimales(){
      return new Promise((resolve, reject) => {
          let numero_decimales = 19;
          this.parametroService.getById(numero_decimales).subscribe(
              res => {
                  this.numero_decimales = res.valor;

                  let digitos = "";
                  for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                  this.format_decimal = "0,0." + digitos
                  resolve();
              },
              err => {
                  this.numero_decimales = 2;
                  this.format_decimal = "0,0.00"
                  reject(err);
              }
          );
      });
  }

  get formatDecimal(){
      return this.format_decimal;
  }

	onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if(res == "ok"){
					this.ordenService.delete(id).subscribe(
						res => {
							if(res.message){
								this.getOrdenes();
								this.msg.showMessage('success-message',res.message);
							}
						},
						err => {
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}

	onPrint(orden){
    let params = [];
    params["usuario_id"] = this.ss.getData('usuario_id');
    let qs = [];
    if (orden.bodega_id) {
      params["bodega_id"] = orden.bodega_id;
    }
    for(let key in params){
      let str = key + "=" + params[key];
      qs.push(str);
    }
    const initialState = {route: "orden-compra/" + orden.id,  qs: "?" + qs.join("&")+ "&dbname="+this.ss.getData('dbname')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  }

  onShow(id){
		const initialState = {orden_id: id, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(OrdenCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  }
  
  

  next(){
    this.pagination.current_page++;
    this.getOrdenes();
  }

  prev(){
    this.pagination.current_page--;
    this.getOrdenes();
  }

  first(){
    this.pagination.current_page = 1;
    this.getOrdenes();
  }

  last(){
    this.pagination.current_page = this.pagination.last_page;
    this.getOrdenes();
  }

  getIndexNumber(i){
    return this.pagination.from+i;
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/orden-compra-list/orden-compra-list.component.ts